import SuccessContainer from "./SuccessContainer";

export default SuccessContainer;
